<template>
<div class="contacts" v-if="siteInfo">
    <div class="contacts__container container">
        <div class="contacts__info">
            <div class="contacts__info-title">
                КОНТАКТЫ
            </div>
            <a v-if="siteInfo.phone"
               :href="phoneHref(siteInfo.phone)"
               class="contacts__info-item __phone"
            >
                {{ phoneFormatted(siteInfo.phone) }}
            </a>
            <a
                v-if="siteInfo.email"
                :href="'mailto:' + siteInfo.email"
                class="contacts__info-item __mail">
                {{ siteInfo.email }}
            </a>
            <a
                target="_blank"
                href="https://2gis.ru/krasnoyarsk/search/%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D1%8F%D1%80%D1%81%D0%BA%2C%20%D0%9A%D0%BE%D0%BC%D1%81%D0%BE%D0%BC%D0%BE%D0%BB%D0%BB?m=92.902201%2C56.019255%2F17.43"
                v-if="siteInfo.address"
                class="contacts__info-item __address"
            >
                {{ siteInfo.address }}
            </a>
            <div
                v-if="siteInfo.working_time"
                class="contacts__info-item __work-time">
                {{ siteInfo.working_time }}
            </div>
            <ContactForm
              id="form"
            />
        </div>
        <div class="contacts__map">
            <div id="2GisMap" style="width:500px; height: 100%"></div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import gMap from '2gis-maps'
import ContactForm from './ContactForm.vue'

export default {
    name: "Contacts",
    props: {
        siteInfo: {}
    },
    components: {
      ContactForm
    },
    data() {
        return {
            marker: [56.02019521210351, 92.90100000690573]
        }
    },
    methods: {
        async init() {
            let map
            gMap.then(() => {
                map = DG.map('2GisMap', {
                    'center': this.marker,
                    'zoom': 16
                });
                DG.marker(this.marker).addTo(map).bindPopup('КомсоМОЛЛ')
            })
        },
        phoneHref(phone) {
            if (!phone) return '';

            let digits = phone.toString().replace(/[^\d]/g, '');

            if (!digits) return '';

            return `tel:+${digits}`;
        },
        phoneFormatted(phone) {
            if (!phone) return '';

            let digits = phone.toString().replace(/[^\d]/g, '');

            if (digits.length < 11) {
                return phone;
            }

            return '+' + digits[0] + ' (' + digits.slice(1, 4) + ') ' + digits.slice(4, 7) + '-' + digits.slice(7, 9) + '-' + digits.slice(9, 11);
        }
    },
    async mounted() {
        setTimeout(() => {
            this.init();
        }, 3000)
    }
}
</script>

<style lang="scss">
.contacts {
    position: relative;
    background: #fff;
    color: #000;

    &:before {
        position: absolute;
        content: '';
        top: -20px;
        width: 100%;
        height: 20px;
        background: linear-gradient(90deg, #4961F9 0%, #FF4747 49.33%, #FFB72A 100.76%);
        z-index: 1;
    }

    &__container {
        position: relative;
        display: flex;
        padding: 150px 0;

        @include below($mobile) {
            flex-direction: column;
            padding: 80px 0 75px;
        }
    }

    &__sale {
      color: #FE4546;
    }

    &__info {
        display: flex;
        flex-direction: column;
        width: calc(100% / 2 - 20px);

        @include below($mobile) {
            width: 100%;
        }

        &-title {
            font-family: BOWLER, sans-serif;
            font-size: 50px;
            font-weight: 400;
            margin-bottom: 15px;

            @include below($mobile) {
                font-size: 34px;
                line-height: 40px;
                text-align: left;
            }
        }

        &-item {
            position: relative;
            margin: 25px 0 0 30px;
            color: #6F6F6F;
            transition: .2s ease-in-out;

            @include below($mobile) {
                margin: 15px 0 0 30px;
                font-size: 16px;
            }

            &.__phone:hover,
            &.__mail:hover {
                color: #2a2a2a;
            }

            &:before {
                position: absolute;
                content: '';
                width: 18px;
                height: 18px;
                left: -30px;
                top: 50%;
                transform: translateY(-50%);
                background: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.3639 8.14214V7.57645C17.3639 7.49181 17.3639 7.44948 17.3634 7.41368C17.3247 4.7083 15.1409 2.52454 12.4355 2.4858C12.3997 2.48528 12.3574 2.48528 12.2728 2.48529H11.7071M7.77785 6.17314C7.32461 7.21293 7.554 8.42416 8.35605 9.22622L10.7529 11.623C11.5549 12.4251 12.7661 12.6545 13.8059 12.2012C14.8457 11.748 16.057 11.9774 16.859 12.7794L18.3172 14.2376C18.3878 14.3083 18.4232 14.3436 18.4518 14.3747C19.1548 15.1399 19.1548 16.316 18.4518 17.0811C18.4232 17.1123 18.3878 17.1476 18.3172 17.2182L17.4309 18.1046C16.7091 18.8264 15.6685 19.1294 14.6721 18.9079C7.88248 17.3991 2.57995 12.0966 1.07115 5.307C0.849715 4.31054 1.15272 3.27001 1.87451 2.54821L2.76085 1.66187C2.8315 1.59123 2.86682 1.5559 2.89794 1.52731C3.6631 0.82423 4.83921 0.82423 5.60436 1.52731C5.63548 1.5559 5.67081 1.59123 5.74145 1.66187L7.19965 3.12007C8.0017 3.92212 8.23109 5.13336 7.77785 6.17314Z' stroke='%23030303' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A") center/cover no-repeat;
            }

            &.__mail:before {
                width: 21px;
                height: 18px;
                background: url("data:image/svg+xml,%3Csvg width='23' height='20' viewBox='0 0 23 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.92893 5.92893L5.63604 5.22183L4.92893 5.92893ZM3 4L2.29289 4.70711H2.29289L3 4ZM11 18C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20V18ZM21.0451 16.9389L20.2361 16.3511V16.3511L21.0451 16.9389ZM19.9389 18.0451L19.3511 17.2361L19.9389 18.0451ZM19.9389 1.95491L20.5267 1.1459V1.1459L19.9389 1.95491ZM21.0451 3.06107L20.2361 3.64886V3.64886L21.0451 3.06107ZM4.06107 1.95491L3.47329 1.1459V1.1459L4.06107 1.95491ZM1 10C1 10.5523 1.44772 11 2 11C2.55228 11 3 10.5523 3 10H1ZM2.95491 3.06107L2.1459 2.47329V2.47329L2.95491 3.06107ZM1 16C0.447715 16 0 16.4477 0 17C0 17.5523 0.447715 18 1 18V16ZM7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16V18ZM1 13C0.447715 13 0 13.4477 0 14C0 14.5523 0.447715 15 1 15V13ZM4 15C4.55228 15 5 14.5523 5 14C5 13.4477 4.55228 13 4 13V15ZM2.62103 3.62103L1.72016 3.18694L2.62103 3.62103ZM5.63604 5.22183L3.82843 3.41422L2.41422 4.82843L4.22182 6.63604L5.63604 5.22183ZM20.1716 3.41422L18.364 5.22182L19.7782 6.63604L21.5858 4.82843L20.1716 3.41422ZM4.22182 6.63604C5.8685 8.28272 7.17314 9.59036 8.33123 10.474C9.5124 11.3752 10.6579 11.9289 12 11.9289V9.92893C11.271 9.92893 10.5477 9.64938 9.5444 8.88391C8.51806 8.10084 7.3227 6.90848 5.63604 5.22183L4.22182 6.63604ZM18.364 5.22182C16.6773 6.90848 15.4819 8.10084 14.4556 8.88391C13.4523 9.64938 12.729 9.92893 12 9.92893V11.9289C13.3421 11.9289 14.4876 11.3752 15.6688 10.474C16.8269 9.59036 18.1315 8.28271 19.7782 6.63604L18.364 5.22182ZM5.63604 5.22183L3.70711 3.29289L2.29289 4.70711L4.22182 6.63604L5.63604 5.22183ZM20.2929 3.29289L18.364 5.22182L19.7782 6.63604L21.7071 4.70711L20.2929 3.29289ZM11 2H13V0H11V2ZM13 18H11V20H13V18ZM21 10C21 11.8971 20.9986 13.2397 20.8865 14.275C20.7763 15.2917 20.569 15.8929 20.2361 16.3511L21.8541 17.5267C22.4761 16.6707 22.7462 15.6773 22.8748 14.4905C23.0014 13.3224 23 11.8526 23 10H21ZM13 20C14.8526 20 16.3224 20.0014 17.4905 19.8748C18.6773 19.7462 19.6707 19.4761 20.5267 18.8541L19.3511 17.2361C18.8929 17.569 18.2917 17.7763 17.275 17.8865C16.2397 17.9986 14.8971 18 13 18V20ZM20.2361 16.3511C19.9894 16.6907 19.6907 16.9894 19.3511 17.2361L20.5267 18.8541C21.0361 18.484 21.484 18.0361 21.8541 17.5267L20.2361 16.3511ZM13 2C14.8971 2 16.2397 2.00137 17.275 2.11355C18.2917 2.22369 18.8929 2.43097 19.3511 2.76393L20.5267 1.1459C19.6707 0.523946 18.6773 0.253765 17.4905 0.125182C16.3224 -0.00137258 14.8526 0 13 0V2ZM19.3511 2.76393C19.6907 3.01065 19.9894 3.30928 20.2361 3.64886L21.8541 2.47329C21.484 1.96392 21.0361 1.51597 20.5267 1.1459L19.3511 2.76393ZM11 0C9.14741 0 7.67764 -0.00137258 6.50955 0.125182C5.32274 0.253765 4.32933 0.523946 3.47329 1.1459L4.64886 2.76393C5.10714 2.43097 5.70833 2.22369 6.72497 2.11355C7.76033 2.00137 9.10286 2 11 2V0ZM3.47329 1.1459C2.96392 1.51598 2.51598 1.96392 2.1459 2.47329L3.76393 3.64886C4.01065 3.30928 4.30928 3.01065 4.64886 2.76393L3.47329 1.1459ZM1 18H7V16H1V18ZM1 15H4V13H1V15ZM3 10C3 8.36122 3.00065 7.13221 3.07479 6.15088C3.14875 5.17191 3.291 4.53431 3.5219 4.05512L1.72016 3.18694C1.33003 3.99657 1.16177 4.92408 1.08047 6.00021C0.99935 7.07397 1 8.39003 1 10H3ZM3.5219 4.05512C3.59237 3.90887 3.67239 3.77486 3.76393 3.64886L2.1459 2.47329C1.98228 2.69849 1.84122 2.93569 1.72016 3.18694L3.5219 4.05512ZM3.70711 3.29289L3.32814 2.91392L1.91392 4.32814L2.29289 4.70711L3.70711 3.29289ZM23 10C23 8.39003 23.0007 7.07397 22.9195 6.00021C22.8382 4.92408 22.67 3.99657 22.2798 3.18694L20.4781 4.05512C20.709 4.53431 20.8513 5.17191 20.9252 6.15088C20.9993 7.13221 21 8.36122 21 10H23ZM22.2798 3.18694C22.1588 2.93569 22.0177 2.69849 21.8541 2.47329L20.2361 3.64886C20.3276 3.77486 20.4076 3.90887 20.4781 4.05512L22.2798 3.18694ZM21.7071 4.70711L22.0861 4.32814L20.6719 2.91392L20.2929 3.29289L21.7071 4.70711Z' fill='%23030303'/%3E%3C/svg%3E%0A") center/cover no-repeat;
            }

            &.__address:before {
                width: 16px;
                height: 21px;
                background: url("data:image/svg+xml,%3Csvg width='18' height='23' viewBox='0 0 18 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.7808 19.7005L10.9939 19.0834L11.7808 19.7005ZM6.21921 19.7005L5.43231 20.3176L6.21921 19.7005ZM9 22.0055V21.0055V22.0055ZM16 9.6087C16 10.7662 15.3896 12.3589 14.3861 14.1329C13.4048 15.8679 12.1337 17.6299 10.9939 19.0834L12.5677 20.3176C13.7376 18.8257 15.0761 16.9754 16.127 15.1176C17.1556 13.299 18 11.3185 18 9.6087H16ZM7.00611 19.0834C5.86627 17.6299 4.5952 15.8679 3.61385 14.1329C2.61037 12.3589 2 10.7662 2 9.6087H0C0 11.3185 0.844353 13.299 1.87304 15.1176C2.92386 16.9754 4.26239 18.8257 5.43231 20.3176L7.00611 19.0834ZM2 9.6087C2 5.3362 5.2018 2 9 2V0C3.96164 0 0 4.37228 0 9.6087H2ZM9 2C12.7982 2 16 5.3362 16 9.6087H18C18 4.37228 14.0384 0 9 0V2ZM10.9939 19.0834C10.3695 19.8797 9.97671 20.3751 9.63109 20.689C9.32828 20.9641 9.16336 21.0055 9 21.0055V23.0055C9.80987 23.0055 10.4328 22.6627 10.9759 22.1694C11.4761 21.7151 11.9871 21.0579 12.5677 20.3176L10.9939 19.0834ZM5.43231 20.3176C6.0129 21.0579 6.52394 21.7151 7.02415 22.1694C7.56717 22.6627 8.19013 23.0055 9 23.0055V21.0055C8.83664 21.0055 8.67172 20.9641 8.36891 20.689C8.02329 20.3751 7.63055 19.8797 7.00611 19.0834L5.43231 20.3176ZM5 10C5 12.2091 6.79086 14 9 14V12C7.89543 12 7 11.1046 7 10H5ZM9 14C11.2091 14 13 12.2091 13 10H11C11 11.1046 10.1046 12 9 12V14ZM13 10C13 7.79086 11.2091 6 9 6V8C10.1046 8 11 8.89543 11 10H13ZM9 6C6.79086 6 5 7.79086 5 10H7C7 8.89543 7.89543 8 9 8V6Z' fill='%23030303'/%3E%3C/svg%3E%0A") center/cover no-repeat;
            }

            &.__work-time:before {
                width: 21px;
                height: 21px;
                background: url("data:image/svg+xml,%3Csvg width='22' height='23' viewBox='0 0 22 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 8C12 7.44771 11.5523 7 11 7C10.4477 7 10 7.44771 10 8H12ZM8.27239 14.4353C7.89353 14.8372 7.91216 15.4701 8.314 15.8489C8.71585 16.2278 9.34874 16.2092 9.72761 15.8073L8.27239 14.4353ZM1.3753 2.21913C0.944043 2.56414 0.874122 3.19343 1.21913 3.6247C1.56414 4.05596 2.19343 4.12588 2.6247 3.78087L1.3753 2.21913ZM5.12469 1.78087C5.55596 1.43586 5.62588 0.806567 5.28087 0.375305C4.93586 -0.055957 4.30657 -0.125878 3.8753 0.219131L5.12469 1.78087ZM19.3753 3.78087C19.8066 4.12588 20.4359 4.05596 20.7809 3.6247C21.1259 3.19343 21.056 2.56414 20.6247 2.21913L19.3753 3.78087ZM18.1247 0.219131C17.6934 -0.125878 17.0641 -0.055957 16.7191 0.375305C16.3741 0.806567 16.444 1.43586 16.8753 1.78087L18.1247 0.219131ZM10.4552 13.5778L9.72761 12.8918L10.4552 13.5778ZM10 8V12.2058H12V8H10ZM9.72761 15.8073L11.1828 14.2638L9.72761 12.8918L8.27239 14.4353L9.72761 15.8073ZM2.6247 3.78087L5.12469 1.78087L3.8753 0.219131L1.3753 2.21913L2.6247 3.78087ZM20.6247 2.21913L18.1247 0.219131L16.8753 1.78087L19.3753 3.78087L20.6247 2.21913ZM20 12C20 16.9706 15.9706 21 11 21V23C17.0751 23 22 18.0751 22 12H20ZM11 21C6.02944 21 2 16.9706 2 12H0C0 18.0751 4.92487 23 11 23V21ZM2 12C2 7.02944 6.02944 3 11 3V0.999998C4.92487 0.999998 0 5.92487 0 12H2ZM11 3C15.9706 3 20 7.02944 20 12H22C22 5.92487 17.0751 0.999998 11 0.999998V3ZM10 12.2058C10 12.4609 9.90256 12.7063 9.72761 12.8918L11.1828 14.2638C11.7077 13.7071 12 12.9709 12 12.2058H10Z' fill='%23030303'/%3E%3C/svg%3E%0A") center/cover no-repeat;
            }
        }
    }

    &__map {
        margin-left: auto;
        max-height: 700px;
        max-width: 550px;
        border-radius: 50px;
        overflow: hidden;
        z-index: 1;

        img {
            width: 100%;
            height: auto;
        }

        @include below($mobile) {
            display: flex;
            position: absolute;
            top: 330px;
            height: 300px;
            width: 100%;
        }
    }
}
</style>
